export const INVESTMENT_FORM_TABS = [
    { id: 'overview', label: 'Overview' },
    { id: 'share-details', label: 'Share Details' },
    { id: 'tranche-1', label: 'Tranche 1' },
    { id: 'tranche-2', label: 'Tranche 2' },
    { id: 'tranche-3', label: 'Tranche 3' },
    { id: 'post-exit', label: 'Post & Exit' }
];

const today = () => new Date().toISOString().split('T')[0];

export const createEmptyInvestmentFormState = () => ({
    investmentAmount: '',
    currency: 'INR',
    investmentDate: today(),
    equityPercentage: '',
    entrySharePrice: '',
    entryShareEquity: '',
    numberOfShares: '',
    partlyPaidAmount: '',
    nettSubscriptionAmount: '',
    tranche1SubscriptionAmount: '',
    tranche1NoCcps: '',
    tranche1HoldingPercentage: '',
    tranche2SubscriptionAmount: '',
    tranche2NoCcps: '',
    tranche2HoldingPercentage: '',
    postCompletionSubscriptionAmount: '',
    postCompletionNoCcps: '',
    postCompletionHoldingPercentage: '',
    investmentStage: 'SEED',
    investmentType: 'EQUITY',
    accessLevel: 'FULL',
    autoGrantAccess: true,
    boardSeat: false,
    leadInvestor: false,
    exitDate: '',
    exitAmount: '',
    exitValuation: '',
    notes: ''
});

const asString = (value) => (value == null ? '' : String(value));

const asDateString = (value) => {
    if (!value) return '';
    const input = typeof value === 'string' ? value : String(value);
    return input.includes('T') ? input.split('T')[0] : input;
};

export const investmentToFormState = (investment = {}) => ({
    ...createEmptyInvestmentFormState(),
    investmentAmount: asString(investment.investmentAmount),
    currency: investment.currency || 'INR',
    investmentDate: asDateString(investment.investmentDate) || today(),
    equityPercentage: asString(investment.equityPercentage),
    entrySharePrice: asString(investment.entrySharePrice),
    entryShareEquity: asString(investment.entryShareEquity),
    numberOfShares: asString(investment.numberOfShares),
    partlyPaidAmount: asString(investment.partlyPaidAmount),
    nettSubscriptionAmount: asString(investment.nettSubscriptionAmount),
    tranche1SubscriptionAmount: asString(investment.tranche1SubscriptionAmount),
    tranche1NoCcps: asString(investment.tranche1NoCcps),
    tranche1HoldingPercentage: asString(investment.tranche1HoldingPercentage),
    tranche2SubscriptionAmount: asString(investment.tranche2SubscriptionAmount),
    tranche2NoCcps: asString(investment.tranche2NoCcps),
    tranche2HoldingPercentage: asString(investment.tranche2HoldingPercentage),
    postCompletionSubscriptionAmount: asString(investment.postCompletionSubscriptionAmount),
    postCompletionNoCcps: asString(investment.postCompletionNoCcps),
    postCompletionHoldingPercentage: asString(investment.postCompletionHoldingPercentage),
    investmentStage: investment.investmentStage || 'SEED',
    investmentType: investment.investmentType || 'EQUITY',
    accessLevel: investment.accessLevel || 'FULL',
    autoGrantAccess: investment.autoGrantAccess !== undefined ? investment.autoGrantAccess : true,
    boardSeat: !!investment.boardSeat,
    leadInvestor: !!investment.leadInvestor,
    exitDate: asDateString(investment.exitDate),
    exitAmount: asString(investment.exitAmount),
    exitValuation: asString(investment.exitValuation),
    notes: investment.notes || ''
});

const parseOptionalFloat = (value) => {
    if (value == null || String(value).trim() === '') return null;
    const parsed = parseFloat(value);
    return Number.isNaN(parsed) ? null : parsed;
};

const parseOptionalInt = (value) => {
    if (value == null || String(value).trim() === '') return null;
    const parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? null : parsed;
};

export const buildInvestmentUpdatePayload = (formState) => ({
    investmentAmount: parseFloat(formState.investmentAmount),
    investmentDate: formState.investmentDate ? new Date(formState.investmentDate).toISOString() : null,
    equityPercentage: parseOptionalFloat(formState.equityPercentage),
    entrySharePrice: parseOptionalFloat(formState.entrySharePrice),
    entryShareEquity: parseOptionalFloat(formState.entryShareEquity),
    numberOfShares: parseOptionalInt(formState.numberOfShares),
    partlyPaidAmount: parseOptionalFloat(formState.partlyPaidAmount),
    nettSubscriptionAmount: parseOptionalFloat(formState.nettSubscriptionAmount),
    tranche1SubscriptionAmount: parseOptionalFloat(formState.tranche1SubscriptionAmount),
    tranche1NoCcps: parseOptionalInt(formState.tranche1NoCcps),
    tranche1HoldingPercentage: parseOptionalFloat(formState.tranche1HoldingPercentage),
    tranche2SubscriptionAmount: parseOptionalFloat(formState.tranche2SubscriptionAmount),
    tranche2NoCcps: parseOptionalInt(formState.tranche2NoCcps),
    tranche2HoldingPercentage: parseOptionalFloat(formState.tranche2HoldingPercentage),
    postCompletionSubscriptionAmount: parseOptionalFloat(formState.postCompletionSubscriptionAmount),
    postCompletionNoCcps: parseOptionalInt(formState.postCompletionNoCcps),
    postCompletionHoldingPercentage: parseOptionalFloat(formState.postCompletionHoldingPercentage),
    investmentStage: formState.investmentStage,
    investmentType: formState.investmentType,
    currency: formState.currency,
    accessLevel: formState.accessLevel,
    autoGrantAccess: formState.autoGrantAccess,
    notes: formState.notes || '',
    boardSeat: formState.boardSeat,
    leadInvestor: formState.leadInvestor,
    exitDate: formState.exitDate ? new Date(formState.exitDate).toISOString() : null,
    exitAmount: parseOptionalFloat(formState.exitAmount),
    exitValuation: parseOptionalFloat(formState.exitValuation)
});
